'use strict';
import {stateGo} from 'redux-ui-router';
import {ASSET_COLLECTION} from '../assets/domain/config';
import {assetsStates} from '../assets/router-config';
import {getCollection, getDomainLink, getId, getLink} from '../core-utilities/domain/ReduxUtils';
import {ORGANIZATION_COLLECTION} from '../organizations/domain/config';
import {TEAM_COLLECTION} from '../personnel/domain/config';
import {personnelStates} from '../personnel/router';
import {ASSET_PROJECT_COLLECTION, PROJECT_COLLECTION} from '../projects/domain/config';
import {
  ASSET_FILE_REQUIREMENT_COLLECTION,
  ASSET_FORM_REQUIREMENT_COLLECTION,
  FILE_ASSET_COLLECTION,
  FILE_REQUIREMENT_COLLECTION,
  FORM_REQUIREMENT_COLLECTION,
} from '../requirements/domain/config';
import {
  assetFileRequirementStates,
  assetFormRequirementStates,
  projectFileRequirementStates,
  projectFormRequirementStates,
} from '../requirements/router-config';
import {ASSET_TASK_COLLECTION, TASK_COLLECTION} from '../tasks/domain/config';
import {assetTasksStates, projectTasksStates, templateTasksStates} from '../tasks/router-config';


AppNavigatorService.$inject = [
  '$ngRedux',
  '$model',
  '$domain',
];

export function AppNavigatorService(
  $ngRedux,
  $model,
  $domain,
) {

  this.goToLink = goToLink;
  this.goToInstance = goToInstance;

  function goToLink(link) {
    const domainClass = $domain.getDomain(link.collection);
    return domainClass.$get(link.id).then(goToInstance);
  }

  function goToInstance(instance) {
    const navDeferred = Promise.defer();
    const collection = getCollection(instance);
    switch (collection) {
      case TEAM_COLLECTION:
        navDeferred.resolve(null);
        $ngRedux.dispatch(stateGo(personnelStates.teamsDetail, {teamId: getId(instance)}));
        break;
      case PROJECT_COLLECTION:
        $model
          .hydrate({
            organization: getLink(instance, 'organization'),
            project: {id: getId(instance), collection: getCollection(instance)},
          })
          .then(() => {
            navDeferred.resolve(null);
            $ngRedux.dispatch(stateGo(projectTasksStates.tasks));
          })
          .catch(navDeferred.reject.bind(navDeferred));
        break;
      case ASSET_PROJECT_COLLECTION:
        $model
          .hydrate({
            organization: {id: instance.org, collection: ORGANIZATION_COLLECTION},
            project: getLink(instance, 'project'),
            asset: getLink(instance, 'asset'),
          })
          .then(() => {
            navDeferred.resolve(null);
            $ngRedux.dispatch(stateGo(assetTasksStates.tasks));
          })
          .catch(navDeferred.reject.bind(navDeferred));
        break;
      case ASSET_COLLECTION:
        $model
          .hydrate({
            organization: {id: instance.org, collection: ORGANIZATION_COLLECTION},
            asset: {id: getId(instance), collection: getCollection(instance)},
          })
          .then(() => {
            navDeferred.resolve(null);
            $ngRedux.dispatch(stateGo(assetsStates.assetsHome));
          })
          .catch(navDeferred.reject.bind(navDeferred));
        break;
      case TASK_COLLECTION:
        $model
          .hydrate({
            organization: {id: instance.org, collection: ORGANIZATION_COLLECTION},
            project: getLink(instance, 'project'),
          })
          .then(() => {
            navDeferred.resolve(null);

            if (instance.assetSpecific) {
              $ngRedux.dispatch(stateGo(templateTasksStates.requirements, {taskId: getId(instance)}));
            } else {
              $ngRedux.dispatch(stateGo(projectTasksStates.requirements, {taskId: getId(instance)}));
            }
          })
          .catch(navDeferred.reject.bind(navDeferred));
        break;
      case ASSET_TASK_COLLECTION:
        $model
          .hydrate({
            organization: {id: instance.org, collection: ORGANIZATION_COLLECTION},
            project: getLink(instance, 'project'),
            asset: {id: instance.ast, collection: ASSET_COLLECTION},
          })
          .then(() => {
            navDeferred.resolve(null);
            $ngRedux.dispatch(stateGo(assetTasksStates.requirements, {taskId: getId(instance)}));
          })
          .catch(navDeferred.reject.bind(navDeferred));
        break;
      case FILE_REQUIREMENT_COLLECTION:
        $model
          .hydrate({
            organization: {id: instance.org, collection: ORGANIZATION_COLLECTION},
            project: {id: instance.prj, collection: PROJECT_COLLECTION},
          })
          .then(() => {
            navDeferred.resolve(null);
            $ngRedux.dispatch(stateGo(projectFileRequirementStates.details, {requirementId: getId(instance)}));
          })
          .catch(navDeferred.reject.bind(navDeferred));
        break;
      case FORM_REQUIREMENT_COLLECTION:
        $model
          .hydrate({
            organization: {id: instance.org, collection: ORGANIZATION_COLLECTION},
            project: {id: instance.prj, collection: PROJECT_COLLECTION},
          })
          .then(() => {
            navDeferred.resolve(null);
            $ngRedux.dispatch(stateGo(projectFormRequirementStates.details, {requirementId: getId(instance)}));
          })
          .catch(navDeferred.reject.bind(navDeferred));
        break;
      case ASSET_FILE_REQUIREMENT_COLLECTION:
        $model
          .hydrate({
            organization: {id: instance.org, collection: ORGANIZATION_COLLECTION},
            project: {id: instance.prj, collection: PROJECT_COLLECTION},
            asset: {id: instance.ast, collection: ASSET_COLLECTION},
          })
          .then(() => {
            navDeferred.resolve(null);
            $ngRedux.dispatch(stateGo(assetFileRequirementStates.details, {requirementId: getId(instance)}));
          })
          .catch(navDeferred.reject.bind(navDeferred));
        break;
      case ASSET_FORM_REQUIREMENT_COLLECTION:
        $model
          .hydrate({
            organization: {id: instance.org, collection: ORGANIZATION_COLLECTION},
            project: {id: instance.prj, collection: PROJECT_COLLECTION},
            asset: {id: instance.ast, collection: ASSET_COLLECTION},
          })
          .then(() => {
            navDeferred.resolve(null);
            $ngRedux.dispatch(stateGo(assetFormRequirementStates.details, {requirementId: getId(instance)}));
          })
          .catch(navDeferred.reject.bind(navDeferred));
        break;
      case FILE_ASSET_COLLECTION:
        getDomainLink(instance, 'fulfillment')
          .then(fileFulfillment => getDomainLink(fileFulfillment, 'requirement'))
          .then(fileRequirement => {
            const collection = getCollection(fileRequirement);
            switch (collection) {
              case FILE_REQUIREMENT_COLLECTION:
                return $model
                  .hydrate({
                    organization: {id: fileRequirement.org, collection: ORGANIZATION_COLLECTION},
                    project: {id: fileRequirement.prj, collection: PROJECT_COLLECTION},
                  })
                  .then(() => {
                    navDeferred.resolve(null);
                    $ngRedux.dispatch(stateGo(
                      projectFileRequirementStates.details,
                      {requirementId: getId(fileRequirement)},
                    ));
                  })
                  .catch(navDeferred.reject.bind(navDeferred));

              case ASSET_FILE_REQUIREMENT_COLLECTION:
                return $model
                  .hydrate({
                    organization: {id: fileRequirement.org, collection: ORGANIZATION_COLLECTION},
                    project: {id: fileRequirement.prj, collection: PROJECT_COLLECTION},
                    asset: {id: fileRequirement.ast, collection: ASSET_COLLECTION},
                  })
                  .then(() => {
                    navDeferred.resolve(null);
                    $ngRedux.dispatch(stateGo(
                      assetFileRequirementStates.details,
                      {requirementId: getId(fileRequirement)},
                    ));
                  })
                  .catch(navDeferred.reject.bind(navDeferred));

            }
          })
          .catch(navDeferred.reject.bind(navDeferred));// TODO: show $toast if an error occurs, informing user the app failed to resolve the destination
        break;
      default:
        return Promise.reject(new Error(`Unsupported link collection: {${collection}}`));
    }

    return navDeferred.promise;
  }
}



// WEBPACK FOOTER //
// ./src/js/app-model/AppNavigatorService.js